export interface IActivitiesParams {
  sort: string;
  page: number;
  size: number;
  facilityIds?: string;
}
export const getActivitiesRequestParams = (
  sort: string,
  page: number,
  size: number,
  facilityIds?: string
) => {
  const params = {} as IActivitiesParams;
  if (sort) {
    params['sort'] = sort;
  }
  if (page) {
    params['page'] = page;
  }
  if (size) {
    params['size'] = size;
  }
  if (facilityIds) {
    params['facilityIds'] = facilityIds;
  }
  return params;
};
